import registerReducer from './registerReducer';

export * from './registerActions';
export default registerReducer;
